import { useMutation, useQueryClient } from '@tanstack/react-query';
import expensesApi from '@/features/dashboard/expenses/api/expensesApi.ts';
import { expensesApiQueryKeys } from '@/features/dashboard/expenses/api/expensesApi.queryKeys.ts';
import { invalidateFinanceRelatedQueries } from '@/utils/invalidateFinanceQueries.ts';
import { invalidateAttentionQueries } from '@/utils/invalidateAttentionQueries.ts';
import { toast } from 'sonner';

/**
 * Kasowanie wydatku jest zablokowane (400), gdy są na nim pieniądze — wtedy
 * właściwą akcją jest anulowanie, które odpina zapłaty i zwraca transakcje
 * do puli niezaalokowanych.
 */
export default function useCancelExpense(tourId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (expenseId: string) => expensesApi.cancel(tourId, expenseId),
    onSuccess: (_data, expenseId) => {
      invalidateFinanceRelatedQueries(queryClient);
      queryClient.invalidateQueries({
        queryKey: expensesApiQueryKeys.byId(tourId, expenseId),
      });
      void invalidateAttentionQueries(queryClient, tourId);
      toast.success('Wydatek został anulowany', {
        description:
          'Wpięte zapłaty wróciły do puli transakcji do rozdysponowania.',
      });
    },
    onError: (error: Error) => {
      toast.error('Wystąpił błąd', {
        description:
          error.message || 'Wystąpił błąd podczas anulowania wydatku.',
      });
    },
  });
}
